import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingModule } from '../loading';
import { IconModule } from '../icon';
import { ButtonComponent } from './button.component';

@NgModule({
  declarations: [ButtonComponent],
  imports: [CommonModule, LoadingModule, IconModule],
  exports: [ButtonComponent],
})
export class ButtonModule {}
